import script from "./Prints.vue?vue&type=script&setup=true&lang=js"
export * from "./Prints.vue?vue&type=script&setup=true&lang=js"

import "./Prints.vue?vue&type=style&index=0&id=b4753e62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4753e62"]])

export default __exports__